export const sv = {
  colVehicle: 'Fordon',
  colLocation: 'Plats',
  colIssues: 'Fel',
  issuesCount: '{n} fel',
  extrasCount: '+{n} tillval',
  colQuotes: 'Offerter',
  quotesCount: '{n} offerter',
  colStatus: 'Status',
  cancelled: 'Avbruten',
  colReceived: 'Mottagen',
  title: 'Förfrågningar',
  subtitle: 'Hantera inkommande besiktningsförfrågningar',
  searchPlaceholder: 'Sök på registreringsnummer eller märke...',
  statusAll: 'Alla statusar',
  statusOpen: 'Öppna',
  statusBooked: 'Bokade',
  statusClosed: 'Stängda',
  tableTitle: 'Inkommande förfrågningar',
  emptyMessage: 'Inga förfrågningar hittades',
}

export const en: typeof sv = {
  colVehicle: 'Vehicle',
  colLocation: 'Location',
  colIssues: 'Faults',
  issuesCount: '{n} faults',
  extrasCount: '+{n} add-ons',
  colQuotes: 'Quotes',
  quotesCount: '{n} quotes',
  colStatus: 'Status',
  cancelled: 'Cancelled',
  colReceived: 'Received',
  title: 'Requests',
  subtitle: 'Manage incoming inspection requests',
  searchPlaceholder: 'Search by registration number or make...',
  statusAll: 'All statuses',
  statusOpen: 'Open',
  statusBooked: 'Booked',
  statusClosed: 'Closed',
  tableTitle: 'Incoming requests',
  emptyMessage: 'No requests found',
}
